import dataStore from '../../data/data';

const Connect = async (socket) => {
  return new Promise((resolve)=>{
    const data = dataStore.getState();
    let registered = false;
  
    if (!data.mirror.vitruvianId) {
      console.log('Missing ID');
      return;
    }

    const register = () => {
      if (registered) return;
      registered = true;

      socket.send(JSON.stringify({
        action: 'register',
        sessionId: data.mirror.sessionId,
        vitruvianId: data.mirror.vitruvianId,
      }));

      dataStore.setState((_data) => ({
        ..._data,
        mirror: {
          ..._data.mirror,
          connected: true,
        },
      }));

      resolve();
    };

    if (socket.readyState === WebSocket.OPEN) {
      register();
    } else {
      socket.addEventListener('open', register, { once: true });
    }
    
    socket.addEventListener('message', (event) => {
      const message = JSON.parse(event.data);
    });

    socket.onerror = (err) => {
      console.log('WebSocket error:', err);
    };
  
    socket.onclose = () => {
      console.log('WebSocket closed');
      dataStore.setState((_data) => ({
        ..._data,
        mirror: {
          ..._data.mirror,
          connected: false
        }
      }));
    };
  })

};

export default Connect;